<template>
    <v-layout class="main-wrap"
              justify-center
              align-center
    >
        <div class="login-wrap">
            <v-form ref="form"
                    class="form"
                    v-model="valid"
                    lazy-validation
                    @submit.prevent=""
            >
                <v-layout class="mt-10">
                    <div>
                        <v-layout align-center justify-start class="input-row">
                                <span class="input-label">
                                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/login_id.png" />
                                </span>
                            <input type="text" class="input-field username" v-model="username" />
                        </v-layout>
                        <v-layout align-center justify-start class="input-row">
                                <span class="input-label">
                                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/login_pw.png" />
                                </span>
                            <input type="password" class="input-field passwd" v-model="passwd" />
                        </v-layout>
                    </div>
                    <div class="btn-wrap">
                        <button class="btn-login" @click="login">
                            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/login_btn_txt.png" />
                        </button>
                    </div>
                </v-layout>
            </v-form>
        </div>
    </v-layout>
</template>

<script>
    export default {
        data() {
            return {
                valid: false,
                username: '',
                passwd: '',
            }
        },
        mounted() {
        },
        methods: {
            login() {
                this.$playAudio(1)

                const self = this

                this.$store.commit('setUserAction', '1|')

                if (!this.username) {
                    self.$store.commit('showDialog',{
                        type: 'alert',
                        message: '아이디를 입력해주세요.',
                        okCb: ()=>{
                            setTimeout(_ => {
                                $('.username').focus()
                            })
                        }
                    });
                    return;
                }
                if (!this.passwd) {
                    self.$store.commit('showDialog',{
                        type: 'alert',
                        message: '비밀번호를 입력해주세요.',
                        okCb: ()=>{
                            setTimeout(_ => {
                                $('.passwd').focus()
                            })
                        }
                    });
                    return;
                }

                const params = {
                    username: this.username,
                    passwd: this.passwd,
                }
                this.axios.post('/api/login', params).then(response => {
                    if (response.data.code === '9011') {

                        self.$store.commit('showDialog',{
                            type: 'alert',
                            message: response.data.message,
                            okCb: ()=>{
                                setTimeout(_ => {
                                    $('.email').focus()
                                })
                            }
                        });
                    } else if (response.data.code === '9012') {

                        self.$store.commit('showDialog',{
                            type: 'alert',
                            message: response.data.message,
                            okCb: ()=>{
                                setTimeout(_ => {
                                    $('.passwd').focus()
                                })
                            }
                        });
                    } else if (response.data.code === '9501' || response.data.code === '9502') {

                        self.$store.commit('showDialog',{
                            type: 'alert',
                            message: response.data.message.replace(/\\n/g, '\n'),
                            okCb: ()=>{
                            }
                        });
                    } else if (response.data.code === '0000') {
                        const trainee = response.data.result
                        self.$cookie.set('token', trainee.token, 30)
                        self.$cookie.set('name', trainee.name, 30)
                        self.$cookie.set('id', trainee.id, 30)
                        self.$cookie.set('training_id', trainee.training_id, 30)
                        self.$cookie.set('gender', trainee.gender)

                        let userData = localStorage.getItem(`userData${trainee.id}`)
                        if (userData) {
                            userData = JSON.parse(userData)
                            if (trainee.move_to_sheet) {
                                this.$router.replace('/sheet')
                            } else if (userData.ended) {
                                this.$router.replace('/result')
                            } else {
                                this.$router.replace('/game')
                            }
                        } else {
                            this.$router.replace('/tutorial')
                        }
                    }
                })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-wrap {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #000000;

        .login-wrap {
            display: flex;
            justify-content: center;
            align-items: flex-end;

            padding-bottom: 151px;

            width: 945px;
            height: 590px;
            font-weight: 600;
            font-size: 20px;
            text-align: center;
            background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_login.png);

            .input-row {
                .input-label {
                    display: inline-block;
                    width: 53px;
                    text-align: right;
                    padding-right: 8px;

                    img {
                        height: 19px;
                    }
                }

                .input-field {
                    background-color: #ffffff;
                    width: 156px;
                    box-shadow: 5px 6px #000000;
                    font-size: 15px;
                    padding: 4px 10px;
                }

                &+.input-row {
                    margin-top: 10px;
                }
            }


            .btn-login {
                color: #19162a;
                width: 78px;
                height: 71px;
                margin-left: 8px;
                background-color: #fbb040;
                box-shadow: 5px 6px #000000;
            }
        }
    }
</style>
